import * as storePayments from './views/store/payments.js';
import * as storeSubscriptions from './views/store/subscriptions.js';
import popupPaymentPlugin, { showPayment, closePayment, cancelPayment } from './views/plugins/popup.payment.plugin.js';

import addRoutes from '@martyrs/src/modules/core/views/router/addRoutes.js';
import { getPaymentsRoutes } from './views/router/payments.router.js';
import { i18nManager } from '@martyrs/src/modules/core/views/classes/i18n.manager.js';
import locales from './views/locales/index.js';

// Component re-exports
export { default as PaymentHistory } from './views/components/pages/PaymentHistory.vue';
export { default as Subscriptions } from './views/components/pages/Subscriptions.vue';
export { default as Plans } from './views/components/pages/Plans.vue';
export { default as PopupPayment } from './views/components/blocks/PopupPayment.vue';
export { default as CardPlan } from './views/components/blocks/CardPlan.vue';
export { default as CardPaymentMethod } from './views/components/blocks/CardPaymentMethod.vue';

function initializePayments(app, store, router, options = {}) {
  i18nManager.register('payments', locales);

  const paymentsRoute = getPaymentsRoutes(options);
  addRoutes(router, { ...paymentsRoute.config, parentName: paymentsRoute.parentName });

  store.addStore('payments', storePayments);
  store.addStore('subscriptions', storeSubscriptions);

  app.use(popupPaymentPlugin);

  app.provide('store', store);
}

export {
  storePayments,
  storeSubscriptions,
  initializePayments as initialize,
  showPayment,
  closePayment,
  cancelPayment,
};

export default {
  initialize: initializePayments,
  views: {
    store: { storePayments, storeSubscriptions },
    router: { getPaymentsRoutes },
  },
};
